<template>
  <div
    v-if="isVisible"
    class="feedback-entry"
    :class="{ 'feedback-entry--collapsed': isScrolling }"
    @click="handleFeedback"
  >
    <div class="feedback-entry__btn">
      <div class="feedback-entry__text">反馈</div>
    </div>
  </div>
</template>

<script>
import { log } from '@ali/amap-lib';
import jumpHandler from '../../../common/js/jump-handler';

const FEEDBACK_URL = 'https://zbrs7j.aliwork.com/o/feedkback';

export default {
  name: 'FeedbackEntry',
  props: {
    isInAmap: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      status: 'visible',
      fid: '',
      isJumpPending: false,
      isScrolling: false,
      scrollTimer: null,
    };
  },
  computed: {
    isVisible() {
      return this.status === 'visible';
    },
  },
  created() {
    this.fid = this.generateFid();
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.$nextTick(() => {
      this.report('feedback_show');
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
    }
  },
  methods: {
    generateFid() {
      try {
        if (window.crypto && window.crypto.getRandomValues) {
          const buffer = new Uint8Array(16);
          window.crypto.getRandomValues(buffer);
          const hexParts = [];
          for (let i = 0; i < buffer.length; i += 1) {
            const hex = buffer[i].toString(16);
            hexParts.push(hex.length === 1 ? `0${hex}` : hex);
          }
          return hexParts.join('');
        }
      } catch (error) {
        // fall through to compatibility fallback
      }
      return `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    },
    report(event) {
      if (!this.fid) {
        return;
      }
      log.log(event, {
        fid: this.fid,
        url: window.location.href,
      });
    },
    handleScroll() {
      this.isScrolling = true;
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
      }
      this.scrollTimer = setTimeout(() => {
        this.isScrolling = false;
      }, 200);
    },
    handleFeedback() {
      if (this.status !== 'visible' || this.isJumpPending) {
        return;
      }
      this.isJumpPending = true;
      const currentFid = this.fid;
      this.report('feedback_clk');
      const targetUrl = `${FEEDBACK_URL}?fid=${encodeURIComponent(currentFid)}`;
      jumpHandler(targetUrl, {
        needSchema: this.isInAmap,
      });
      setTimeout(() => {
        this.isJumpPending = false;
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.feedback-entry {
  position: fixed;
  right: 0;
  bottom: 2.3rem;
  z-index: 100;
  // 透明 padding 扩大点击热区，可视样式由 __btn 承载
  padding: 0.2rem 0 0.2rem 0.2rem;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  cursor: pointer;

  &--collapsed {
    .feedback-entry__btn {
      width: 0.2rem;
      padding: 0;
    }

    .feedback-entry__text {
      opacity: 0;
    }
  }

  &__btn {
    position: relative;
    right: -0.04rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 0.48rem;
    height: 0.9rem;
    background: #3d7eff;
    border-radius: 0.16rem 0 0 0.16rem;
    box-shadow: -0.02rem 0.02rem 0.08rem rgba(61, 126, 255, 0.3);
    overflow: hidden;
    transition: width 0.3s ease;
  }

  &__text {
    border: none;
    background: transparent;
    padding: 0;
    margin: 0;
    outline: none;
    color: #ffffff;
    -webkit-appearance: none;
    appearance: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    cursor: pointer;
    font-size: 0.28rem;
    width: 0.28rem;
    word-break: break-all;
    text-align: center;
    line-height: 1.1;
    transition: opacity 0.2s ease;
  }
}
</style>
